<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getCustomerListFromFilter" :items-per-page="40"
    :filter="filter" :min-search-char-limit="3" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
    :singleline="singleline" :returnobject="returnobject" :disabled="disabled" :loading="loading" valuekey="Id"
    textkey="Name" :label="label ? label : $t('servicesystem.common_objects.customer.customer')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.customer.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
    <template v-slot:prepend-outer>
      <v-icon size="18" class="mt-1">$customer</v-icon>
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "CustomerSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    singleline: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>